import * as Yup from 'yup'
import { Form } from 'react-bootstrap'

export const Schema = Yup.object().shape({
    terms: Yup.bool().required().oneOf([true], 'The privacy policy must be accepted'),
});

export const PrivacyConsentSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { dataSecurityUrl } = props;
    return (
        <>
            <Form.Group controlId="privacyConsent">
                <Form.Label>Please confirm*</Form.Label>
                <Form.Check
                    required
                    name="terms"
                    type="checkbox"
                    onChange={handleChange}
                    isInvalid={touched.terms && !!errors.terms}
                    feedback={errors.terms}
                    feedbackType="invalid"
                    label={<span>I agree to the <a href={dataSecurityUrl} target="_blank" rel="noreferrer" >privacy policy</a>.</span>}>
                </Form.Check>
            </Form.Group>
        </>
    );
};